import { useContext } from 'react';
import { GameContext } from 'contexts/GameContext';
import { Paragraph, ExternalLink } from 'elements/Text';

const Copyright = () => {
  const { copyright } = useContext(GameContext) || {};

  return (
    <>
      {copyright &&
        <Paragraph>Game &copy;{copyright}</Paragraph>
      }
      <Paragraph>Site &copy;2022, <ExternalLink target="_blank" href="https://daisy.works">Daisy W.</ExternalLink></Paragraph>
    </>
  );
}

export default Copyright;
